<template>
    <Modal v-if="showModal" @closeClicked="hideModal">
        <template v-slot:header>
            <div>
                <h1 class="text-17px mb-5px">Import portfolios from Google Sheets</h1>
                <div class="text-grey-light">This will import all spreadsheets/tabs from the given URL</div>
            </div>
        </template>

        <template v-slot:body>
            <p v-if="error" class="text-red mb-10px">{{ error }}</p>
            <input type="text" placeholder="https://docs.google.com/spreadsheets/d/..." v-model="spreadsheetUrl">
        </template>

        <template v-slot:footer>
            <div class="buttons text-right">
                <div class="button" @click="hideModal">Cancel</div>
                <div class="button green" @click="importPortfolios">Import</div>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from '@/components/global/Modal'
import { getSpreadsheet } from '@/api/gSheets'

export default {
    components: { Modal },
    props:{
        showModal: Boolean, // showModal.sync
    },
    data(){
        return{
            spreadsheetUrl: '',
            error: '',
            busy: false,
        }
    },
    computed:{
        spreadsheetKey(){
            if(this.spreadsheetUrl.includes('docs.google.com/spreadsheets/d/')){
                // get ID from https://docs.google.com/spreadsheets/d/<ID>/edit
                const id = this.spreadsheetUrl.split('docs.google.com/spreadsheets/d/')[1].split('/')[0]
                return id
            }
            return null
        }
    },
    methods:{
        hideModal(){
            this.spreadsheetUrl = ''
            this.error = ''
            this.busy = false
            this.$emit('update:showModal', false)
        },
        async importPortfolios(){

            if(this.busy){
                this.error = 'Import busy'
                return
            }

            const portfolios = JSON.parse(localStorage.getItem('portfolios') || '[]')

            if(portfolios.length > 0){
                this.error = 'There are already one or more portfolios set. Please delete any existing portfolios first.'
                return
            }

            if(this.spreadsheetKey == null){
                this.error = 'Please enter a valid spreadsheet url'
                return
            }

            this.busy = true

            const spreadsheetInfo = await getSpreadsheet(this.spreadsheetKey)

            const importedPortfolios = []

            for(const sheet of spreadsheetInfo.sheets){
                importedPortfolios.push({
                    name: sheet.properties.title,
                    spreadsheetKey: this.spreadsheetKey,
                    spreadsheetTab: sheet.properties.title,
                    spreadsheetTabId: sheet.properties.sheetId
                })
            }

            localStorage.setItem('portfolios', JSON.stringify(importedPortfolios))
            this.hideModal()
            this.$emit('portfoliosImported')
        }
    }
}
</script>